// extracted by mini-css-extract-plugin
module.exports = {"component":"checkbox-group_component__SUYeC","heading":"checkbox-group_heading__n28ZG","optionsContainer":"checkbox-group_optionsContainer__xDawV"};